/* unplugin-vue-components disabled */import script from "./relateTeamModal.vue?vue&type=script&setup=true&lang=js"
export * from "./relateTeamModal.vue?vue&type=script&setup=true&lang=js"

import "./relateTeamModal.vue?vue&type=style&index=0&id=038a5e58&lang=scss"

const __exports__ = script;

export default __exports__